module.exports = __webpack_public_path__ + "static/023.thumb-fa63117a7657259afe93be273ae832f1.jpg";